import "@/style.scss";
import { definePreset } from "@primevue/themes";
import Aura from "@primevue/themes/aura";
import "primeicons/primeicons.css";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import Badge from "primevue/badge";
import BlockUI from "primevue/blockui";
import Button from "primevue/button";
import ButtonGroup from "primevue/buttongroup";
import Card from "primevue/card";
import Checkbox from "primevue/checkbox";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import PrimeVue from "primevue/config";
import ConfirmDialog from "primevue/confirmdialog";
import ContextMenu from "primevue/contextmenu";
import DataTable from "primevue/datatable";
import Dialog from "primevue/dialog";
import DialogService from "primevue/dialogservice";
import Divider from "primevue/divider";
import Drawer from "primevue/drawer";
import DynamicDialog from "primevue/dynamicdialog";
import FileUpload from "primevue/fileupload";
import FloatLabel from "primevue/floatlabel";
import Fluid from "primevue/fluid";
import InputText from "primevue/inputtext";
import Listbox from "primevue/listbox";
import Menu from "primevue/menu";
import MenuBar from "primevue/menubar";
import Message from "primevue/message";
import Popover from "primevue/popover";
import Panel from "primevue/panel";
import Password from "primevue/password";
import ProgressBar from "primevue/progressbar";
import Ripple from "primevue/ripple";
import Select from "primevue/select";
import SelectButton from "primevue/selectbutton";
import Slider from "primevue/slider";
import SpeedDial from "primevue/speeddial";
import SplitButton from "primevue/splitbutton";
import TabMenu from "primevue/tabmenu";
import TabPanel from "primevue/tabpanel";
import TabView from "primevue/tabview";
import Tag from "primevue/tag";
import Textarea from "primevue/textarea";
import TieredMenu from "primevue/tieredmenu";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";
import ToggleSwitch from "primevue/toggleswitch";
import Toolbar from "primevue/toolbar";
import Tooltip from "primevue/tooltip";
import TreeSelect from "primevue/treeselect";
import { App } from "vue";

import { ConfirmPopup } from "./custom/components";
import { ConfirmationService } from "./custom/services";

// css token customizations
const StekzAuraPreset = definePreset(Aura, {
    semantic: {
        primary: {
            950: "#41157f",
            900: "#41157f",
            800: "#41157f",
            700: "#41157f", // todo a darker variant from 700 & up
            600: "#41157f",
            500: "#6220bf",
            400: "#842cff",
            300: "#a367ff",
            200: "#c29cff",
            100: "#e4d4ff",
            50: "#e4d4ff", // todo add a lighter variant for prime
        },
    },
    components: {
        select: {
            border: {
                radius: 0,
            },
            overlay: {
                border: {
                    radius: 0,
                },
            },
        },
    },
});
export function initPrimeVue(app: App<Element>) {
    app.use(PrimeVue, {
        // Default theme configuration
        ripple: true,
        theme: {
            preset: StekzAuraPreset,
            options: {
                prefix: "p",
                darkModeSelector: ".dark-mode",
                cssLayer: false, // Todo see https://v4.primevue.org/theming/styled/#csslayer
            },
        },
    });

    app.use(ConfirmationService);
    //https://primevue.org/dynamicdialog/
    app.use(DialogService);
    app.use(ToastService);

    app.component("Accordion", Accordion);
    app.component("AccordionTab", AccordionTab);
    app.component("Badge", Badge);
    app.component("BlockUI", BlockUI);
    app.component("Button", Button);
    app.component("ButtonGroup", ButtonGroup);
    app.component("Card", Card);
    app.component("ConfirmDialog", ConfirmDialog);
    app.component("ConfirmPopup", ConfirmPopup);
    app.component("ContextMenu", ContextMenu);
    app.component("Dialog", Dialog);
    app.component("DynamicDialog", DynamicDialog);
    app.component("Menu", Menu);
    app.component("MenuBar", MenuBar);
    app.component("TieredMenu", TieredMenu);
    app.component("Select", Select);
    app.component("FileUpload", FileUpload);
    app.component("SplitButton", SplitButton);
    app.component("Toast", Toast);
    app.component("Toolbar", Toolbar);
    app.component("InputText", InputText);
    app.component("Message", Message);
    app.component("DataTable", DataTable);
    app.component("Column", Column);
    app.component("Panel", Panel);
    app.component("Textarea", Textarea);
    app.component("TabMenu", TabMenu);
    app.component("Tag", Tag);
    app.component("Drawer", Drawer);
    app.component("Listbox", Listbox);
    app.component("ColumnGroup", ColumnGroup);
    app.component("TabView", TabView);
    app.component("TabPanel", TabPanel);
    app.component("Checkbox", Checkbox);
    app.component("SelectButton", SelectButton);
    app.component("SpeedDial", SpeedDial);
    app.component("Slider", Slider);
    app.component("ToggleSwitch", ToggleSwitch);
    app.component("Password", Password);
    app.component("ProgressBar", ProgressBar);
    app.component("TreeSelect", TreeSelect);
    app.component("Divider", Divider);
    app.component("FloatLabel", FloatLabel);
    app.component("Fluid", Fluid);
    app.component("Popover", Popover);

    // PrimeVue Directives
    app.directive("ripple", Ripple);
    app.directive("tooltip", Tooltip);
}

export const baseSuccessToastMessage = {
    severity: "success" as const,
    life: 5000,
    closable: true,
};
